import http from '@/libs/http'



/**
 * 获取列表
 * */
export const getOrderRateList = (orderId,
                                 userId,
                                 clerkId,
                                 content,
                                 isAnonymous,
                                 isAuto,
                                 isShow,
                                 createdStart,
                                 createdEnd,
                                 pageNo,
                                 pageSize) => {
  return http.request({
    url: '/s/groupPurchaseOrder/rate/list',
    params: {
      orderId,
      userId,
      clerkId,
      content,
      isAnonymous,
      isAuto,
      isShow,
      createdStart,
      createdEnd,
      pageNo,
      pageSize
    },
    method: 'get'
  })
}

/**
 * 订单评价详情
 * */
export const getRate = (rateId) => {
  return http.request({
    url: '/s/groupPurchaseOrder/rate/getRate',
    params: {
      rateId
    },
    method: 'get'
  })
}

/**
 * 修改评价显示状态
 */
export const updateIsShow = (id, isShow) => {
  return http.request({
    url: '/s/groupPurchaseOrder/rate/updateIsShow',
    params: {
      id,
      isShow
    },
    method: 'post'
  })
}



